<script setup>
import ModalBrandPromo from '@/components/ModalBrandPromo.vue';

</script>

<template>
  <Suspense>
    <ModalBrandPromo :autoOpen="false" />
  </Suspense>
</template>
